<template>
  <GbwapsLayout :title="pageTitle" :intro="pageIntro" :breadcrumb="breadcrumbItems">
    <div class="card">
      <p>
        此页面内容将在后续 Phase 开发。当前为 <strong>Phase 1</strong> 路由骨架占位。
      </p>
      <p class="text-center mt-24">
        <router-link class="btn-primary" to="/download/">Download GB WhatsApp APK</router-link>
      </p>
    </div>
  </GbwapsLayout>
</template>

<script>
import GbwapsLayout from '@/layouts/GbwapsLayout.vue';

export default {
  name: 'PagePlaceholder',
  components: { GbwapsLayout },
  computed: {
    pageTitle() {
      return this.$route.meta.pageTitle || 'GBWaps';
    },
    pageIntro() {
      return this.$route.meta.pageIntro || '';
    },
    breadcrumbItems() {
      const crumbs = this.$route.meta.breadcrumb || [];
      return [{ name: 'Home', to: '/' }, ...crumbs];
    },
  },
};
</script>
